const campaign = {
    lines : 1,
    survey_campaign : 'no',
    arriving_leads : 'no',
    admin_conference_rooms : 'yes',
    cool_down_time : 4,
    answeringMachineSound_id: undefined,
    waiting_leads_sound_id: undefined,
    auto_select_active_call: true,
    waiting_music: 'silence'
}


export const state = () => {
    return {
        dispositions: [],
        campaign: {...campaign},
        connection: false
    }
}

export const mutations = {
    setDispositions(state, dispositions) {
        state.dispositions = dispositions
    },
    setCampaign(state, campaign) {
        state.campaign = campaign
    },
    resetCampaign(state) {
        state.campaign = {...campaign}
    },
    setConnection(state, connection) {
        state.connection = connection
    },
}

